const Logger = require('./logger')
const Slack = require('./slackNotifications')
const { getSlackFields } = require('./slackHeaders')

const { SITE_URL } = process.env

const dateToPST = () => {
  const date = new Date()
  const utcTime = date.getTime() + date.getTimezoneOffset() * 60000
  return Math.floor(utcTime / 1000) // Convert to SQL Timestamp
}

const saRedirect = (req, res, url, code) => {
  const { storeLocale } = req
  const urlStoreLocale = storeLocale === 'en-us' ? '' : `/${storeLocale}`
  // TODO - LOOK AT THIS COMMENT
  // Duplicate/Similar Code ( Reason FLOW syntax - components/GeoLocation/helpers )
  const result = new URL(url || '', SITE_URL || 'https://www.saatchiart.com')
  const { origin, pathname, search } = result
  const updatedPath = pathname.replace(/^\/en-[A-Za-z]{2}/, '')
  const redirectURL = `${origin}${urlStoreLocale}${updatedPath}${search || ''}`
  if (code) {
    return res.redirect(code, redirectURL)
  }
  return res.redirect(redirectURL)
}

/* duplicated from lib/helpers because of ES5 require */
const objectToQueryString = (obj) => {
  return Object.keys(obj)
    .map((key) => {
      const val = obj[key]

      if (Array.isArray(val)) {
        return val.map((item) => `${key}=${encodeURIComponent(item)}`).join('&')
      } else if (val !== '') {
        return `${key}=${encodeURIComponent(val) || ''}`
      } else {
        return null
      }
    })
    .filter(Boolean)
    .join('&')
}

module.exports = {
  dateToPST,
  getSlackFields,
  Logger,
  saRedirect,
  Slack,
  objectToQueryString,
}
